// Phantom wallet glue (signTransaction only; we send and confirm ourselves).
import { PublicKey } from "@solana/web3.js";

const listeners = new Set();
let current = null; // PublicKey | null

export function getProvider() {
  const p = window.phantom?.solana || window.solana;
  return p && p.isPhantom ? p : null;
}

export const walletKey = () => current;
export function onWalletChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
function set(pk) {
  const next = pk ? new PublicKey(pk.toString()) : null;
  if ((next && current && next.equals(current)) || (!next && !current)) return;
  current = next;
  for (const fn of listeners) {
    try {
      fn(current);
    } catch (e) {
      console.error(e);
    }
  }
}

export async function connectWallet() {
  const p = getProvider();
  if (!p) {
    window.open("https://phantom.app/", "_blank", "noopener");
    throw new Error("Phantom wallet not found. Install Phantom and reload the page.");
  }
  const res = await p.connect();
  set(res?.publicKey || p.publicKey);
  return current;
}

export async function disconnectWallet() {
  const p = getProvider();
  try {
    await p?.disconnect();
  } catch {
    /* ignore */
  }
  set(null);
}

export async function signTx(tx) {
  const p = getProvider();
  if (!p || !current) throw new Error("Connect your Phantom wallet first.");
  return p.signTransaction(tx);
}

export function initWallet() {
  const p = getProvider();
  if (!p) return;
  p.on?.("connect", (pk) => set(pk || p.publicKey));
  p.on?.("disconnect", () => set(null));
  p.on?.("accountChanged", (pk) => {
    if (pk) set(pk);
    else p.connect({ onlyIfTrusted: true }).then((r) => set(r.publicKey)).catch(() => set(null));
  });
  p.connect({ onlyIfTrusted: true })
    .then((r) => set(r?.publicKey || p.publicKey))
    .catch(() => {});
}
